var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.formated.number)+" "),(_vm.formated.exponenta != 0)?_c('span',[_vm._v(" * 10"),_c('sup',[_vm._v(_vm._s(_vm.formated.exponenta))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }